import React from 'react';
import PropTypes from 'prop-types';
import Button from '@deliveroo/consumer-component-library/components/Button';

import styles from './CreditRedemptionActions.scss';

export default function CreditRedemptionActions({ actions }) {
  return (
    <div className={styles.actions}>
      {actions.map((action, index) => {
        const { title, level, href, onClick, icon, id, isDisabled } = action;

        return (
          <Button
            key={id}
            type={level}
            href={href}
            onClick={onClick}
            icon={icon}
            spacing={index > 0 ? 'small 0 0 0' : undefined}
            isDisabled={isDisabled}
            isBlock
          >
            {title}
          </Button>
        );
      })}
    </div>
  );
}

CreditRedemptionActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      level: PropTypes.oneOf(['primary', 'secondary']).isRequired,
      href: PropTypes.string,
      onClick: PropTypes.func,
      title: PropTypes.string.isRequired,
      icon: PropTypes.elementType, // eslint-disable-line react/no-typos
      isDisabled: PropTypes.bool,
    }),
  ).isRequired,
};
